import parse from "html-react-parser";

export function renderRichText(text, map) {
	return parse(text, {
		replace: (node) => {
			if (node.name && map[node.name])
				return map[node.name](node.children[0].data);
		},
	});
}
